import { Link } from "gatsby";
import React from "react";
import bgVideo from "../../../../../images/backgroundVideos/usecasesbg.mp4";
import BlogInfo from "./BlogInfo";
import { RenderSvg } from "../../../../../utils/helpers/helper";
import BackgroundWave from "../../../../../components/layoutSections/BackgroundWave";

export default function BlogBanner({ blog, styles }) {
  const { pdf, blogTitle, blog_category, readTime } = blog || {};
  const { PdfFile } = pdf || {};

  const bgColor = "grey";
  return (
    <div className={styles?.blogSingleContainer}>
      {/* <video
        autoPlay
        loop
        muted
        playsInline
        controls={false}
        className={styles?.bgVideo}
      >
        <source src={bgVideo} type="video/mp4" />
      </video> */}

      <BackgroundWave bgColor={bgColor} />

      <div className={styles?.blogSingleWrap}>
        <div>
          <Link to="/resources/blogs">
            <span style={{ display: "flex" }}>
              <RenderSvg
                IconName={"chevron-left"}
                style={{ height: "15px", color: "#009bff" }}
              />
            </span>
            Back to Blogs
          </Link>
        </div>
        <div>
          <h2 className="heading-tertiary-lg">{blogTitle}</h2>
        </div>
        <BlogInfo
          blogTitle={blogTitle}
          blog_category={blog_category}
          styles={styles}
          PdfFile={PdfFile}
          readTime={readTime || "5 min"}
          className="mobile-hide"
        />
      </div>
    </div>
  );
}
